import GtmEmitterState from './gtm_emitter_state'
import { ItemShownEvent } from '~/shared/event_subjects'
import GtmEmitter from './gtm_emitter'
import ElapsedTimeCounter from './elapsed_time_counter'
import PlaceEnteredGtmEmitterState from './place_entered_gtm_emitter_state'
import TerminatedGtmEmitterState from './terminated_gtm_emitter_state'

export default class InitialGtmEmitterState extends GtmEmitterState {
  onEnterState (context: GtmEmitter) {
    context.resetStoreData()
    context.timeCounter = new ElapsedTimeCounter()
    context.timeCounterSubscription = context.timeCounter.onElapsedAsObservable()
      .subscribe((elapsedSec) => {
        context.store.elapsedSec = elapsedSec
      })
  }

  onPlaceChanged (context: GtmEmitter, e: ItemShownEvent) {
    context.changeState(new PlaceEnteredGtmEmitterState(e))
  }

  onEnterPage (context: GtmEmitter, pageData: {}) {
    // do nothing
  }

  onEvent (context: GtmEmitter, name: string, data: {} = {}) {
    // do nothing
  }

  terminate (context: GtmEmitter) {
    context.changeState(new TerminatedGtmEmitterState())
  }
}
